import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-40a9446e")

_pushScopeId("data-v-40a9446e")
const _hoisted_1 = { class: "twoBytwo-order" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "読む順番：", -1)
const _hoisted_3 = { class: "select" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  for: `order_1`,
  class: "thumbnail"
}, [
  /*#__PURE__*/_createVNode("img", { src: "/orders/rtlb.svg" })
], -1)
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: `order_2`,
  class: "thumbnail"
}, [
  /*#__PURE__*/_createVNode("img", { src: "/orders/ltrb.svg" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("input", {
          id: `order_1`,
          type: "radio",
          name: "order",
          value: _ctx.pattern00.id,
          checked: _ctx.order == _ctx.pattern00.order,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
        }, null, 40, ["value", "checked"]),
        _hoisted_5
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("input", {
          id: `order_2`,
          type: "radio",
          name: "order",
          value: _ctx.pattern01.id,
          checked: _ctx.order == _ctx.pattern01.order,
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
        }, null, 40, ["value", "checked"]),
        _hoisted_7
      ])
    ])
  ]))
})